import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { provideNgxMask } from 'ngx-mask';

import { PublicFooterComponent } from '@sondermind/features/app-footer';
import { ConfigurationModule } from '@sondermind/configuration';
import { DatadogLoggingModule } from '@sondermind/datadog-logging';
import { PublicHeaderModule } from '@sondermind/features/app-header';
import { BrowseTherapistsCard } from '@sondermind/features/browse-therapists-card';
import { PageNotFoundComponent } from '@sondermind/features/page-not-found';
import { ProviderCalendarComponent } from '@sondermind/features/public-facing/provider-calendar';
import { QuickCheckoutComponent } from '@sondermind/features/public-facing/session-request';
import { SupportPhoneNumberCardComponent } from '@sondermind/features/support-phone-number-card';
import { IrisButtonModule } from '@sondermind/iris/button';
import { IrisCardModule } from '@sondermind/iris/card';
import { IrisIconComponent } from '@sondermind/iris/icon';
import { IrisIconButtonModule } from '@sondermind/iris/icon-button';
import { IrisProgressBarModule } from '@sondermind/iris/progress-bar';
import { IrisRadioGroupModule } from '@sondermind/iris/radio-group';
import { LAUNCH_DARKLY_SERVICE, LaunchDarklyService } from '@sondermind/launch-darkly';
import { LoggingInitModule } from '@sondermind/logging-init';
import { NativeAppInterfaceModule } from '@sondermind/native-app-interface';
import { AUTH_SERVICE } from '@sondermind/utilities/models-auth';
import { ENVIRONMENT } from '@sondermind/utilities/models-environment';
import { WINDOW } from '@sondermind/utilities/tools';

import { environment } from '../environments/environment';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { ConnectCardComponent } from './components/connect-card/connect-card.component';
import { DirectoryComponent } from './components/directory/directory.component';
import { LandingPageHeaderComponent } from './components/landing-page-header/landing-page-header.component';
import { LandingPageComponent } from './components/landing-page/landing-page.component';
import { ProviderDetailsComponent } from './components/provider-details/provider-details.component';

@NgModule({
  declarations: [
    AppComponent,
    DirectoryComponent,
    LandingPageComponent,
  ],
  imports: [
    PageNotFoundComponent,
    BrowserAnimationsModule,
    BrowserModule,
    CommonModule,
    ConnectCardComponent,
    DatadogLoggingModule.forRoot(environment),
    IrisButtonModule,
    IrisCardModule,
    IrisIconButtonModule,
    IrisIconComponent,
    IrisRadioGroupModule,
    IrisProgressBarModule,
    LandingPageHeaderComponent,
    ProviderDetailsComponent,
    ProviderCalendarComponent,
    PublicFooterComponent,
    PublicHeaderModule,
    SupportPhoneNumberCardComponent,
    QuickCheckoutComponent,
    AppRoutingModule,
    ConfigurationModule,
    LoggingInitModule,
    ProviderCalendarComponent,
    NativeAppInterfaceModule,
    BrowseTherapistsCard
  ],
  providers: [
    { provide: ENVIRONMENT, useValue: environment },
    { provide: LAUNCH_DARKLY_SERVICE, useClass: LaunchDarklyService },
    { provide: WINDOW, useValue: window },
    { provide: AUTH_SERVICE, useValue: { getAuthToken: () => '' } },
    provideNgxMask()
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
